import moment from 'moment';

export const getMonthsBetweenDates = (birthday: string) => {
  const startDate = moment(birthday, 'YYYY-MM-DD');
  const endDate = moment(moment(), 'YYYY-MM-DD');

  return endDate.diff(startDate, 'months');
};

export const getPreciseMonthsBetweenDates = (birthday: string) => {
  const startDate = moment(birthday, 'YYYY-MM-DD');

  return moment().diff(startDate, 'months', true);
};
